<template>
  <v-layout row align-center justify-space-between class="farm-item">
    <v-flex class="my-2" grow>
      <div class="font-weight-bold label my-1">#{{farm.id}}</div>
      <div class="font-weight-regular name my-1">{{farm.name}}</div>
    </v-flex>
    <v-flex shrink>
      <v-layout column align-end justify-center>
        <div class="font-weight-bold text-uppercase label my-1">Certification</div>
        <v-icon dark class="circle my-1">check</v-icon>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: 'FarmItem',
  props: ['farm']
}
</script>

<style lang="scss" scoped>

.circle{
  border-radius: 50%;
  background: #378e07;
}

.label{
  font-size: 11px;
}

.name{
  font-size: 16px;
}

</style>
